"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getFeatureName } from '@autoguru/feature-identification';
import { ENV_NAME, TENANT_NAME } from '@autoguru/global-configs';
export const buildLogContext = (contexts = {}) => {
  var _GDU_APP_NAME__;
  return _objectSpread(_objectSpread({}, contexts), {}, {
    featureName: getFeatureName(),
    mfeAppName: ((_GDU_APP_NAME__ = __GDU_APP_NAME__) === null || _GDU_APP_NAME__ === void 0 ? void 0 : _GDU_APP_NAME__.replace('@autoguru/', '')) || 'NA',
    ag_env: ENV_NAME,
    ag_tenant: TENANT_NAME,
    screenWidth: process.__browser__ ? window.screen.width : 'NA',
    screenHeight: process.__browser__ ? window.screen.height : 'NA',
    screenAspectRatio: process.__browser__ ? window.screen.width / window.screen.height : 'NA',
    windowHeight: process.__browser__ ? window.innerHeight : 'NA',
    windowWidth: process.__browser__ ? window.innerWidth : 'NA'
  });
};